import { useState } from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
import Image from 'next/legacy/image'
import CircularProgress from '@material-ui/core/CircularProgress'
import { PlayAnimated, playAnimation } from 'components/icons'
import { Typography } from 'common/typography'

const FreeVideoLazy = dynamic(
  () => import('./free-class-lazy'),
  {
    loading: () => (
      <div className="video-thumb" id="video-card-hover">
        <img width="587" height="330.19" className="thumb" src="/images/courses/recreando-redux.jpg" alt="thumbnail de la clase gratuita" />
        <div className="video-loading">
          <CircularProgress
            variant="indeterminate"
            size={80}
            thickness={6}
          />
        </div>
      </div>
    ),
  },
)

const FreeVideoStyled = styled.div`
  position: relative;
  ${playAnimation}
  &:hover {
    .title {
      opacity: 1;
    }
  }
  .overlay {
    position: absolute;
    opacity: 0.5;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    background: var(--neutral110);
  }
  .video-thumb {
    position: relative;
    cursor: pointer;
    .thumb {
      width: 100%;
      height: auto;
    }
  }
  .thumb {
    width: 100%;
  }
  .video-loading, .play-container {
    position: absolute;
    top: calc(50% - 40px);
    right: calc(50% - 40px);
  }
  .title {
    opacity: 0;
    position: absolute;
    top: 16px;
    left: 16px;
    transition: 200ms ease-in-out;
    z-index: 1;
    padding: 0.1rem 0.3rem;
    border-radius: 8px;
    background: #000000b3;
  }
  :active .play-container {
    transform: scale(0.95);
  }
`

function FreeVideoComponent({ provider_id, title, thumb }) {
  const [playing, setPlaying] = useState(false)

  return (
    <FreeVideoStyled className="thumb-container" id="free-video-hover">
      {!playing ? (
        <div className="video-thumb" onClick={() => setPlaying(provider_id)}>
          <div className="overlay" />
          <div className="title">
            <Typography as="h5" font="p2Bold" color="white">{title}</Typography>
          </div>
          <Image
            width={686}
            height={386}
            layout="responsive"
            className="thumb"
            src={thumb}
            alt="thumbnail de una clase gratuita"
          />
          <div className="play-container">
            <PlayAnimated width="80px" height="80px" color="white" />
          </div>
        </div>
      ) : (
        <FreeVideoLazy videoId={provider_id} />
      )}
    </FreeVideoStyled>
  )
}

export default FreeVideoComponent
